import React from 'react';
import IconBase from './IconBase';

const ClassStrikethroughIcon = props => {
    return (
        <IconBase viewBox={'0 0 48 48'} {...props}>
            <path d="M5.2,5.8C5,5.5,4.6,5.3,4.2,5.3c-0.4,0-0.8,0.2-1.1,0.5C2.8,6,2.6,6.4,2.6,6.8c0,0.4,0.1,0.8,0.4,1l3.2,3.2c-0.5,0.1-1,0.4-1.4,0.8C4.3,12.5,4,13.2,4,14v19c0,0.8,0.3,1.5,0.9,2.1C5.5,35.7,6.2,36,7,36h2v-3H7V14h2.2l5.3,5.3c0.1,1,0.4,1.8,1.1,2.5c0.7,0.7,1.6,1.1,2.5,1.1l3.2,3.2c-1,0-1.9,0.1-2.9,0.1c0,0-4.7-0.2-5.9,1.2c-0.7,0.8-0.6,2.1-0.6,2.1V40h13V29.8l3.2,3.2H28v3h3.2l8.6,8.6c0.3,0.3,0.7,0.5,1.1,0.5c0.4,0,0.8-0.1,1.1-0.5c0.3-0.3,0.5-0.6,0.5-1c0-0.4-0.2-0.8-0.5-1L5.2,5.8z"/>
            <path d="M41,14v19h-3v-2h-3.2l5,5H41c0.8,0,1.5-0.3,2.1-0.9c0.6-0.6,0.9-1.3,0.9-2.1V14c0-0.8-0.2-1.5-0.8-2.1C42.5,11.3,41.8,11,41,11H14.8l3,3H41z"/>
            <path d="M36.7,27.1c0.3-0.4,0.3-0.8,0.2-1.3c-0.1-0.5-0.4-0.8-0.8-1.1c-0.4-0.2-0.8-0.3-1.3-0.2c-1.8,0.4-3.7,0.7-5.5,1l2.9,2.9c1.2-0.2,2.3-0.4,3.4-0.6C36.1,27.7,36.5,27.5,36.7,27.1z"/>
            <path d="M18.8,15l3.6,3.6c-0.1-1-0.4-1.8-1.1-2.5C20.6,15.5,19.8,15.1,18.8,15z"/>
        </IconBase>
    )
}

export default ClassStrikethroughIcon;